const HANDLERESIZE = {
  // bind event handlers to the `handleResize` method (defined below)
  created() {
    window.addEventListener('resize', this.handleResize)
    this.$store.commit('updateExpand', document.documentElement.clientWidth < 1024 ? true : false)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    // whenever the document is resized, re-set the 'fullHeight' variable
    handleResize() {
      this.$store.commit('updateExpand', document.documentElement.clientWidth < 1024 ? true : false)
    }
  }
}

export default HANDLERESIZE



// WEBPACK FOOTER //
// ./src/mixins/handleResize.js